'use client'

import { BottomSheet } from '@fukku/dialog/BottomSheet/BottomSheet'
import { Content } from '@fukku/dialog/Content/Content'
import type { DialogAPI } from '@fukku/dialog/Dialog'
import { Header } from '@fukku/dialog/Header/Header'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useRef } from 'react'
import { BodyContent } from '../Content/BodyContent'
import { PRICES_TOOLTIP_TITLE } from '../Content/keys'
import type { PricesHistoryComponentProps } from '../ExtraInfo'
import { ExtraInfoButton } from '../ExtraInfoButton'

export function SheetPricesHistory({
	pricesHistory,
	shouldShowDiscount,
	sendAnalytics,
}: Readonly<PricesHistoryComponentProps>) {
	const modalRef = useRef<DialogAPI>(null)

	const { t } = useLabels()

	const handleOnClick = () => {
		sendAnalytics()
		modalRef.current?.show()
	}

	return (
		<>
			<ExtraInfoButton handleOnClick={handleOnClick} />
			<BottomSheet ref={modalRef} title={t(PRICES_TOOLTIP_TITLE)}>
				<Header title={t(PRICES_TOOLTIP_TITLE)} />
				<Content>
					<BodyContent
						pricesHistory={pricesHistory}
						shouldShowDiscount={shouldShowDiscount}
					/>
				</Content>
			</BottomSheet>
		</>
	)
}
